import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../../customHook/getCssStyle';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { DynamicForm } from '../../../components/dynamicForm/dynamicForm';
import CustomPressable from '../../../components/customPressable/customPressable';
import { sendAnalytics } from '../../../Redux/Actions/analyticsAction';
import { MOBILE_CHECKIN_CATEGORY } from '../../../config/Constant';
import { useDispatch } from 'react-redux';
import { ImageComp } from '../../../components/Image/Image';
import { CHEVRON_RIGHT } from '../../../assets';
import FadeTransition from '../../../components/fadeTransition';

const AccompanyGuestDetails = (props) => {
  const { accompanyGuests, accompanyGuestDetailsCompleted, checkinSessionToken, dynamicFormData, handleGoBack, handleCancel, handleNext, primaryBtnTxt, secondaryBtnTxt } = props;

  const {t} = useTranslation();
  const getStyles = useCssStyle();
  const dispatch = useDispatch();
  

  const [accompanyGuestList, setAccompanyGuestList] = useState([]);
  const [accompanyGuestIndex, setAccompanyGuestIndex] = useState(0);
  const [renderGuestDetailsForm, setRenderGuestDetailsForm] = useState(false);
  const [reRenderDynamicForm, setReRenderDynamicForm] = useState(true);


  useEffect(() => {

    if(!accompanyGuestDetailsCompleted){
      setRenderGuestDetailsForm(true);
    }

    if (accompanyGuests?.length) {
      const updatedGuests = accompanyGuests.map((guest, index) => ({
        ...guest,
        firstName: guest.name1 || guest.firstName,
        lastName: guest.name2 || guest.lastName,
      }));
      setAccompanyGuestList(updatedGuests);
    }
    
    dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "COMPANION DETAILS", { "element": "widget", "pageName": "COMPANION DETAILS", "widgetSessionId": checkinSessionToken}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const handleAccompanyNext = async (accompanyGuestData) => {
    const updatedGuestList = [...accompanyGuestList];
    updatedGuestList[accompanyGuestIndex] = { ...updatedGuestList[accompanyGuestIndex], ...accompanyGuestData };

    console.log("Updated Guest List: ", updatedGuestList);
    setAccompanyGuestList(updatedGuestList);
    
        
    if(accompanyGuestIndex === accompanyGuestList.length - 1){
      handleNext(updatedGuestList);
      return;
    }
    
    setAccompanyGuestIndex(accompanyGuestIndex+1);
  }

  const handleAccompanyBack = async () => {

    if(accompanyGuestDetailsCompleted){
      if(renderGuestDetailsForm){
        setRenderGuestDetailsForm(false);
      } else {
        handleGoBack();
      }
      return;
    }

    if(accompanyGuestIndex === 0){
      handleGoBack();
      return;
    }

    setAccompanyGuestIndex(accompanyGuestIndex-1);
  }
  
  const editCompanionDetail = (index) => {
    setAccompanyGuestIndex(index);
    setRenderGuestDetailsForm(true);
  }

  useEffect(()=>{
    setReRenderDynamicForm(false);

    setTimeout(() => {
      setReRenderDynamicForm(true);
    }, 10);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accompanyGuestIndex])


  const handleAccompanyGuestSaveNext = () => {
    handleNext(accompanyGuestList)
  }

  console.log("Accompany Guest List: ", accompanyGuestList[accompanyGuestIndex]);

  return (
    <View style={getStyles(['widgetRootContainer', 'accompanyGuestDetailsRootContainer'])} >
      <HeaderWithBack handleCustomBackPress={handleAccompanyBack} />

      <ScrollView 
        automaticallyAdjustKeyboardInsets={true} 
        contentContainerStyle={getStyles(['widgetmainContainer', 'accompanyGuestDetailsMainContainer'])} 
        showsVerticalScrollIndicator={false}
      >
        <View style={getStyles(['widgetmainContainerHeaderContainer', 'accompanyGuestDetailsHeaderContainer'])}>
          <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'accompanyGuestDetailsHeaderTitleContainer'])}>
            <Text style={getStyles(['widgetmainContainerHeaderTitle', 'accompanyGuestDetailsHeaderTitle'])}>
              {t('check_in.accompany_guest_details.heading')}
            </Text>
          </View>
        </View>

        <View style={getStyles(['widgetmainContainerChildContainer', 'accompanyGuestDetailsMainContainerChildContainer'])}>
          {renderGuestDetailsForm ? 
            <>
              <View style={getStyles(['accompanyGuestDetailsTitleContainer'])}>
                <Text style={getStyles(['accompanyGuestDetailsTitle'])}>{t("check_in.accompany_guest_details.guest_title")}{accompanyGuestIndex+1}</Text>
              </View>
              {accompanyGuestList?.length && reRenderDynamicForm ?
              <FadeTransition duration={200}>
                <DynamicForm
                  dynamicFormData={dynamicFormData}
                  dynamicFormDataValue={accompanyGuestList ? accompanyGuestList[accompanyGuestIndex] : {}}
                  guestDetails={accompanyGuestList[accompanyGuestIndex] || {}}

                  handleNext={handleAccompanyNext}
                  handleGoBack={handleAccompanyBack}
                  primaryBtnTxt={accompanyGuestIndex === accompanyGuestList.length-1 ? primaryBtnTxt : undefined}
                  secondaryBtnTxt={secondaryBtnTxt}
                />
              </FadeTransition>
              : null}
            </>
            : <>
              <View style={getStyles(['accompanyGuestDetailsTitleContainer'])}>
                <Text style={getStyles(['accompanyGuestDetailsTitle'])}>{t("check_in.accompany_guest_details.guest_review_title")}</Text>
              </View>
              {
                accompanyGuestList?.length ? accompanyGuestList.map((guest, index) => {
                  return (
                    <CustomPressable key={guest.id} style={getStyles(['list_itemContainer', 'hcommerce_itemContainer'])} onPress={()=> editCompanionDetail(index)}>
                      <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_itemContainer_textContainer'])}>
                        <Text style={getStyles(['accompanyGuestDetailsReviewItemText'])}>
                          {guest.nameTitle
                            ? `${guest.nameTitle} ${guest.firstName || guest.name1} ${guest.lastName || guest.name2}`
                            : guest.firstName || guest.name1 ? `${guest.firstName || guest.name1} ${guest.lastName || guest.name2}` : `Guest User ${index+1}`}
                        </Text>
                      </View>

                      <View style={getStyles(['list_itemContainer_arrow', 'hcommerce_itemContainer_arrow'])}>
                        <ImageComp source={CHEVRON_RIGHT} style={getStyles(['list_itemContainer_arrow_img'])} />
                      </View>
                    </CustomPressable>
                  )
                }) : null
              }
            </>
          }
        </View>
      </ScrollView>
        
      {!renderGuestDetailsForm && <View id='accompanyGuestUpdateContainer' style={getStyles(['accompanyGuestUpdateContainer'])}>
        <CustomPressable 
          id='primaryBtn' 
          onPress={() => handleAccompanyGuestSaveNext()} 
          style={getStyles(['primaryBtn'])}
        >
          <Text id='primaryBtnTxt' style={getStyles(['primaryBtnTxt'])}>
            {primaryBtnTxt}
          </Text>
        </CustomPressable>
      </View>}

    </View>
  )
}

export default AccompanyGuestDetails
